// Pure math backing the shared time context (useTimeContext): the derived
// default granularity for a newly-picked range, and the recenter window used
// when a record click (alert row / vitals point) lands outside the current
// range. See the API contract's "Frontend gesture contract" section.

export const RECENTER_HALF_WINDOW_MS = 30 * 60 * 1000;

const HOUR_MS = 60 * 60 * 1000;

/**
 * Granularity steps snap DOWN in resolution as the range grows:
 * 10s for <=1h, 60s for <=8h, else 300s. (3s exists as a step but is never
 * the derived default -- only a manual choice via the Segmented control.)
 */
export const deriveDefaultInterval = (rangeMs) => {
  if (rangeMs <= HOUR_MS) return 10;
  if (rangeMs <= 8 * HOUR_MS) return 60;
  return 300;
};

/** True when targetMs falls strictly within [range.startMs, range.endMs]. */
export const isWithinRange = (targetMs, range) =>
  targetMs != null &&
  range != null &&
  targetMs >= range.startMs &&
  targetMs <= range.endMs;

/**
 * The new range a seek to `targetMs` should adopt when it lands outside the
 * current range: +-30 minutes around the target.
 */
export const recenterRangeAround = (
  targetMs,
  halfWindowMs = RECENTER_HALF_WINDOW_MS,
) => ({
  startMs: targetMs - halfWindowMs,
  endMs: targetMs + halfWindowMs,
});
